var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("\n    "+_vm._s(_vm.strings["block"])+"\n    #"+_vm._s(_vm.level)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.strings[("brief_" + _vm.level)])+"\n  ")]),_vm._v(" "),_c('button',{on:{"click":_vm.startNextGame}},[_vm._v("\n    "+_vm._s(_vm.strings["applyButton"])+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a8b54e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brief.vue
// module id = 31
// module chunks = 0